import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { decrypt, encrypt } from '@/utils/des'
const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const encrypts = encrypt(userInfo.password);
      return new Promise((resolve, reject) => {
        login(username, encrypts).then(response => {
          const data = response
          // const tokenStr = data.tokenHead+data.token
          const tokenStr = data.token
          const agency = data.agency
          const user_info = data.data
          sessionStorage.setItem('user_info', JSON.stringify(user_info))
          sessionStorage.setItem('agency', JSON.stringify(agency))
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        let agency = sessionStorage.getItem('agency')
        getInfo().then(response => {
          if (response.code != 200) {
            reject(response.msg)
            return
          }

          if (!agency) {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            removeToken()
            sessionStorage.clear()
            localStorage.clear()
            resolve()
            return
          }
          const data = response.data
          const user_info = data
          sessionStorage.setItem('user_info', JSON.stringify(user_info))
          let avatar = process.env.API_HOST + data.avatar
          commit('SET_ROLES', data.role_id)
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', avatar)
          resolve(response)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          sessionStorage.clear()
          localStorage.clear()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js